module.exports = __webpack_public_path__ + "img/blog-08.7c0e8d87.jpg";